import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen grid place-items-center px-6 relative z-10">
      <div className="text-center" data-testid="payment-cancel-page">
        <h1 className="font-display text-3xl">Checkout cancelled</h1>
        <p className="text-slate-400 mt-3">No charge was made. The vault is still waiting for you.</p>
        <Link to="/" data-testid="payment-cancel-home-link" className="inline-block mt-8 rounded-full bg-emerald-500 text-[#07090E] font-bold px-6 py-3">Back to offers</Link>
      </div>
    </div>
  );
}
